export class ValueUpdater {
    static updateNullableField(oldValue, newValue) {
        return newValue !== undefined ? newValue : oldValue;
    }
    static updateNonNullableField(oldValue, newValue) {
        return newValue !== null && newValue !== void 0 ? newValue : oldValue;
    }
    static updateNullableNumber(oldValue, newValue) {
        if (newValue !== undefined && (newValue === null || Number.isFinite(newValue))) {
            return newValue;
        }
        return oldValue;
    }
    static updateNonNullableNumber(oldValue, newValue) {
        return newValue !== undefined && newValue !== null && typeof newValue !== 'string' && !isNaN(newValue)
            ? newValue
            : oldValue;
    }
    static updateNonNullableNumberOrUnknown(oldValue, newValue) {
        if (newValue === undefined) {
            return undefined;
        }
        else if (newValue !== null && typeof newValue !== 'string' && !isNaN(newValue)) {
            return newValue;
        }
        else {
            return oldValue;
        }
    }
    static updateNonNullableStrictlyPositiveInteger(oldValue, newValue) {
        if (newValue && Number.isInteger(newValue) && newValue > 0) {
            return newValue;
        }
        return oldValue;
    }
    static updateNullableDateFromString(oldValue, newValue) {
        if (newValue === null) {
            return null;
        }
        return newValue !== undefined ? new Date(newValue) : oldValue;
    }
    static getDateValue(input) {
        return input && typeof input === 'string' ? new Date(input) : input;
    }
    static updateNullableString(oldValue, newValue) {
        return newValue === null || (newValue !== undefined && typeof newValue === 'string')
            ? newValue
            : oldValue;
    }
    static updateNonNullableString(oldValue, newValue) {
        return newValue || newValue === '' ? newValue : oldValue;
    }
    static updateNonNullableBoolean(oldValue, newValue) {
        if (newValue === true || newValue === false) {
            return newValue;
        }
        else {
            return oldValue;
        }
    }
}
//# sourceMappingURL=valueUpdater.js.map